import React from 'react';

import { Modal, Button, Row, Col } from 'antd';
import styled from '../../../styled-components';

interface IProp {
    urlPath: string
    actionText: string
    title: string
    actionButton?: boolean
}

class ModalImageComponent extends React.Component<IProp, {}> {
    state = {
        modal2Visible: false,
    }

    setModal2Visible(modal2Visible) {
        this.setState({ modal2Visible });
    }

    render(): JSX.Element {
        return (
            <div>
                {
                    (this.props.actionButton) && (
                        <Button type="primary" onClick={() => this.setModal2Visible(true)}>{this.props.actionText}</Button>
                    )
                }
                {
                    (!this.props.actionButton) && (
                        <a href="javascript:;" onClick={() => this.setModal2Visible(true)}>{this.props.actionText}</a>
                    )
                }
                <Modal
                    wrapClassName="vertical-center-modal"
                    visible={this.state.modal2Visible}
                    closable={false}
                    maskClosable={false}
                    footer={false}
                >
                    <Row>
                        <Col sm={24} md={24} xl={24}>
                            <h3>{this.props.title}</h3>
                        </Col>
                    </Row>

                    <Row className="goepik-component-padding">
                        <Col sm={24} md={24} xl={24}>
                            <GoEpikModalImg>
                                <img className="goepik-modal-img" src={this.props.urlPath} />
                            </GoEpikModalImg>
                        </Col>
                    </Row>
                    <Row type="flex" justify="end">
                        <Col>
                            <Button type="primary" onClick={() => this.setModal2Visible(false)}>
                                FECHAR
                            </Button>
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    };
}

const GoEpikModalImg = styled.div`
    text-align:center;
    
    .goepik-modal-img{
        width: auto;
        max-width: 100%;
        max-height: 500px;
        padding-bottom: 1em;
    }
`;

export default ModalImageComponent;

